import React, { useEffect, useState } from "react";
import { ComboBox, FormSection } from "../../../components";

export default function FormPesquisaFiltroAvancado({
  // initialConsulta,
  fazendas,
  racas,
  onRacaSelected,
  handleConsulta,
}) {
  const [dropdownFazenda, setDropdownFazenda] = useState(false);
  const [inputDropdownFazenda, setInputDropdownFazenda] = useState("");
  const [dropdownRaca, setDropdownRaca] = useState(false);
  const [inputDropdownRaca, setInputDropdownRaca] = useState("");
  const [consulta, setConsulta] = useState("");
  const [depsOpen, setDepsOpen] = useState(true);

  const handleInputFazenda = (value) => {
    setInputDropdownFazenda(value.nomeFantasia);
    setConsulta({ ...consulta, idFazenda: value.idFazenda });
  };

  const handleInputRaca = (value) => {
    setInputDropdownRaca(value.nome);
    onRacaSelected(value);
    setConsulta({ ...consulta, idRaca: value.id });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  // useEffect(() => {
  //   setConsulta(initialConsulta);
  // }, [initialConsulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa por Filtro Avançado" borderBottomWidth={376}>
        <ComboBox
          items={fazendas}
          displayName="nomeFantasia"
          placeholder="Fazenda"
          handleInput={(item) => handleInputFazenda(item)}
        />

        <ComboBox
          items={racas}
          displayName="nome"
          placeholder="Raça"
          handleInput={(item) => handleInputRaca(item)}
        />
      </FormSection>
    </div>
  );
}
